import { render } from "./otherManage.vue?vue&type=template&id=72c9b6fc&scoped=true"
import script from "./otherManage.vue?vue&type=script&lang=js"
export * from "./otherManage.vue?vue&type=script&lang=js"

import "./otherManage.vue?vue&type=style&index=0&id=72c9b6fc&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c9b6fc"]])

export default __exports__